<script lang="ts">
    import type {UserAccountReactivePageData, UserAccountStaticPageData} from '../types';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import {getLocalization} from 'core/svelte-context/context';
    import {getPageContext} from 'shared/layouts/page-context';
    import KpGenericPanel from 'shared/ui-widgets/panel/KpGenericPanel.svelte';
    import KpChipTag from 'shared/ui-widgets/chip/KpChipTag.svelte';

    const localize = getLocalization();

    const pageContext = getPageContext<UserAccountStaticPageData, UserAccountReactivePageData>();
    const user = pageContext.staticData.user;
</script>

{#if user.addresses.length > 0}
    <KpGenericPanel additionalClasses="kp-user-account-address-part"
                    hasBodyPadding="{false}">

        <span slot="heading">
            {localize(/* @kp-localization commons.Adresa */ 'commons.Adresa')}
        </span>

        <div class="addresses-container">
            {#each user.addresses as address}
                <div class="address-row">
                    <div class="information">
                        <span>{address.address.street}</span>
                        <span>{address.address.city}</span>
                        <span>{pipe(address.address.country, loc())}</span>
                        <span>{address.address.postalCode}</span>
                    </div>

                    <div class="address-tags-container">
                        {#if address.source.id !== 'internal'}
                            <KpChipTag chipSize="xs" chipStyle="accent-blue-new">{pipe(address.source, loc())}</KpChipTag>
                        {/if}

                        {#if address.permanent}
                            <KpChipTag chipSize="xs" chipStyle="accent-blue-new">
                                {localize(/* @kp-localization commons.address.permanent */ 'commons.address.permanent')}
                            </KpChipTag>
                        {/if}

                        {#if address.mailing}
                            <KpChipTag chipSize="xs" chipStyle="accent-blue-new">
                                {localize(/* @kp-localization commons.address.postal */ 'commons.address.postal')}
                            </KpChipTag>
                        {/if}
                    </div>
                </div>
            {/each}
        </div>
    </KpGenericPanel>
{/if}

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .addresses-container {
        display: flex;
        flex-direction: column;

        .address-row {
            display: flex;
            gap: @spacing-s;
            justify-content: space-between;
            border-bottom: 1px solid @themed-border-default;
            padding: @spacing-base @spacing-ml;

            &:last-child {
                border-bottom: none;
            }

            .information {
                display: flex;
                flex-direction: column;
            }

            .address-tags-container {
                display: flex;
                justify-content: end;
                flex-wrap: wrap;
                gap: 3px;
            }
        }
    }
</style>